var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { PureComponent } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styled from "styled-components";
import { omit, isFunction } from "lodash";
import History, { appOrContext } from "@irati/utils/history";
import { isPromise } from "@irati/utils/promise";
import id from "@irati/utils/id";
import StyledAnchor from "./styled/Anchor";
var RouterLink = /** @class */ (function (_super) {
    __extends(RouterLink, _super);
    function RouterLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            loading: false
        };
        _this.handleClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, to = _a.to, app = _a.app, scrollToTop = _a.scrollToTop;
            if (isFunction(onClick)) {
                onClick(e);
            }
            History.push(appOrContext({ to: to, app: app }, _this.context), "", { scrollToTop: scrollToTop });
        };
        _this.handleAsyncClick = function () {
            var _a = _this.props, onClick = _a.onClick, app = _a.app, scrollToTop = _a.scrollToTop;
            if (isFunction(onClick)) {
                var result = onClick();
                if (isPromise(result)) {
                    result.then(function (loc) {
                        _this.setState({ loading: false });
                        if (!loc)
                            return;
                        return History.push(appOrContext({ to: loc, app: app }, _this.context), "", { scrollToTop: scrollToTop });
                    }).catch(function (err) {
                        _this.setState({ loading: false });
                        throw err;
                    });
                    _this.setState({ loading: true });
                }
            }
        };
        _this.delegateClick = function (e) {
            e.preventDefault();
            var _a = _this.props, disabled = _a.disabled, async = _a.async;
            var loading = _this.state.loading;
            if (!loading && !disabled) {
                if (async) {
                    _this.handleAsyncClick(e);
                }
                else {
                    _this.handleClick(e);
                }
            }
        };
        return _this;
    }
    RouterLink.prototype.render = function () {
        var _a = this.props, to = _a.to, app = _a.app, disabled = _a.disabled, props = __rest(_a, ["to", "app", "disabled"]);
        var loading = this.state.loading;
        var linkProps = omit(props, ["styled", "async", "onClick", "to"]);
        linkProps.href = appOrContext({ to: to, app: app }, this.context);
        if (linkProps.href && linkProps.href.pathname) {
            linkProps.href = linkProps.href.pathname;
        }
        var Anchor = StyledAnchor;
        if (!props.styled) {
            Anchor = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
        }
        var className = classNames(this.props.className, {
            disabled: disabled || loading,
            loading: loading
        });
        return (React.createElement(Anchor, __assign({ id: id("router-link", this.props) }, linkProps, { className: className, onClick: this.delegateClick })));
    };
    RouterLink.defaultProps = {
        styled: true,
        scrollToTop: true
    };
    RouterLink.contextTypes = {
        appPath: PropTypes.string
    };
    return RouterLink;
}(PureComponent));
export default styled(RouterLink)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
